import { SET_TITLE, SetTitleAction } from "./actionTypes";

export const setTitle = (
  instanceTitle: string,
  instanceId: number
): SetTitleAction => ({
  type: SET_TITLE,
  payload: { instanceTitle, instanceId },
});
